import moment from 'moment';

const defaultFormat = 'YYYY-MM-DD';

export const getTodaysDate = (dateFormat = defaultFormat): string => {
  return moment().format(dateFormat);
};

export const getYesterdaysDate = (dateFormat = defaultFormat): string => {
  return moment().subtract(1, 'days').format(dateFormat);
};

export const formatTimestamp = (timestamp?: string | number) => {
  if (!timestamp || timestamp === 'N/A') return '';
  const numericTimestamp = typeof timestamp === 'string' ? Number(timestamp) : timestamp;
  const date = !isNaN(numericTimestamp) ? new Date(numericTimestamp) : new Date(timestamp);
  if (isNaN(date.getTime())) return '';
  return date.toISOString().split('T')[0];
};
